import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonLoader } from "../common/form";
import FormDrawer from "../common/form-drawer--new";
import {
	toggleLoanRejectionConfirmation,
	bulkUpdateCreditLimit,
	setCreditLimitIds,
	setCreditLimitUpdateText,
} from "store/entities/credit/action";
import { encryptPayload } from "utils/encrypt_decrypt";

const DEFAULT_REASONS = [
	{
		key: "reason1",
		chosen: false,
	},
	{
		key: "reason2",
		chosen: false,
	},
	{
		key: "reason3",
		chosen: false,
	},
	{
		key: "reason4",
		chosen: false,
	},
];
const rejectionReasonsList = ["reason1", "reason2", "reason3", "reason4"];
const reasonTextMap = {
	reason1: "Loan Limit is below ₦70,000",
	reason2: "Salary Account Statement was not provided",
	reason3: "Debt Service Ratio exceeds 33%",
	reason4: "Age Requirement (18 - 59) not met",
};

const LoanRejectionConfirmation = () => {
	const dispatch = useDispatch();
	const {
		bulkUpdateCreditLimitLoading: loading,
		creditLimitIds,
		isRejectionConfirmationOpen,
		bulkUpdateCreditLimitPayload,
		selectedCreditItem,
	} = useSelector((state) => state.entities.credit);
	const [reasons, setReasons] = useState(DEFAULT_REASONS);

	const handleReasonChange = (evt, key) => {
		setReasons((prevReasons) =>
			prevReasons.map((prevReason) => ({
				...prevReason,
				chosen:
					key === prevReason.key
						? !prevReason.chosen
						: prevReason.chosen,
			}))
		);
	};

	const toggleFn = () => {
		setReasons(DEFAULT_REASONS);
		dispatch(setCreditLimitIds([]));
		dispatch(toggleLoanRejectionConfirmation());
	};

	const isSingleRejection =
		creditLimitIds.length === 0 && selectedCreditItem?.id;
	const onProceed = () => {
		const limitIds = isSingleRejection
			? [selectedCreditItem?.id]
			: creditLimitIds;
		const reasonsToSend = reasons
			.filter((rawReason) => rawReason.chosen)
			.map((reason) => reasonTextMap[reason.key].replace(/,/g, ""));
		const payload = {
			limitIds,
			limitStatus: "rejected",
			note: reasonsToSend.join(","),
		};
		dispatch(
			setCreditLimitUpdateText(
				`${
					isSingleRejection
						? "Single limit rejection"
						: "Bulk limit rejection"
				}`
			)
		);
		const encryptedPayload = encryptPayload(payload);
		dispatch(bulkUpdateCreditLimit(encryptedPayload));
	};

	// useEffect(() => console.log({ reasons }), [reasons]);

	useEffect(() => {
		if (
			bulkUpdateCreditLimitPayload?.data?.unresolvedLimits?.length ===
				0 &&
			isRejectionConfirmationOpen
		) {
			toggleFn();
		}
	}, [bulkUpdateCreditLimitPayload]);

	return (
		<FormDrawer
			display="center"
			size="md"
			isOpen={isRejectionConfirmationOpen}
			setIsOpen={() => {}}
		>
			<div
				className="max-w-md"
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "24px",
					padding: "24px",
				}}
			>
				<h1
					className="font-bold"
					style={{
						fontSize: "18px",
						lineHeight: "32px",
						color: "#00171A",
					}}
				>
					Reject Loan Limit
				</h1>

				<div
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "32px",
					}}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							gap: "6px",
						}}
					>
						<p
							style={{
								fontWeight: "500",
								fontSize: "14px",
								lineHeight: "20px",
								color: "#101828",
							}}
						>
							Reason for rejection
						</p>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								backgroundColor: "#F4F4F4",
								borderRadius: "12px",
							}}
						>
							{rejectionReasonsList.map(
								(rejectionReason, idx) => (
									<div
										key={`${rejectionReason}-${idx}`}
										className="flex items-center"
										style={{
											height: "40px",
											padding: "10px 16px",
											gap: "12px",
										}}
									>
										<div
											style={{
												width: "16px",
												height: "16px",
												display: "flex",
											}}
										>
											<input
												type="checkbox"
												className="form-checkbox w-full h-full multi-select"
												onChange={(evt) =>
													handleReasonChange(
														evt,
														rejectionReason
													)
												}
												checked={
													reasons.find(
														(reason) =>
															reason.key ===
															rejectionReason
													)?.chosen || false
												}
												value={
													reasonTextMap[
														rejectionReason
													]
												}
											/>
										</div>
										<p
											style={{
												fontSize: "14px",
												lineHeight: "20px",
												color: "#1A202C",
											}}
										>
											{reasonTextMap[rejectionReason]}
										</p>
									</div>
								)
							)}
						</div>
					</div>

					<div className="flex items-center justify-center lg:flex-row">
						<button
							onClick={toggleFn}
							className="btn btn-md border border-ep-primary-500 text-ep-primary-500 focus:ring-0 w-full lg:w-2/4 mr-4"
							disabled={loading}
							style={{
								height: "48px",
								borderRadius: "8px",
								fontSize: "16px",
								lineHeight: "20px",
								fontWeight: "500",
							}}
						>
							Cancel
						</button>

						<ButtonLoader
							loading={loading}
							disabled={!reasons.some((item) => item.chosen)}
							onClick={onProceed}
							className="z-5 btn btn-md border bg-red-500 text-white focus:ring-0 w-full lg:w-2/4"
							style={{
								height: "48px",
								borderRadius: "8px",
								fontSize: "16px",
								lineHeight: "20px",
								fontWeight: "500",
							}}
						>
							{loading ? "Submitting..." : "Reject"}
						</ButtonLoader>
					</div>
				</div>
			</div>
		</FormDrawer>
	);
};

export default LoanRejectionConfirmation;
